import {Link, LinkProps} from '@chakra-ui/react';
import moment from 'moment';
import React, {memo} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {TRACKER_TYPES} from '~/constants/tracker';
import {AppDispatch} from '~/redux/root-store';
import {setTracker} from '~/redux/tracker/slice';
import {TrackerApiItem} from '~/types/models/tracker';
import {isStringOrNumber} from '~/utils/helpers';

interface Props extends LinkProps {
  actionName?: string;
}

export const UiLink = memo(
  React.forwardRef<HTMLAnchorElement, any>(({actionName = '', children, onClick, ...rest}: Props, ref) => {
    const {pathname, search} = useLocation();
    const dispatch: AppDispatch = useDispatch();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      const value = actionName || (isStringOrNumber(children) ? children : '');

      const action: TrackerApiItem = {
        duration: 0,
        path: `${pathname}${search}`,
        triggered_at: moment().format(),
        type: TRACKER_TYPES.LINK,
        value: value,
      };
      dispatch(setTracker(action));
      if (onClick) {
        onClick(e);
      }
    };

    return (
      <Link onClick={handleClick} {...rest}>
        {children}
      </Link>
    );
  }),
);
